(function () {
  'use strict';

  if (window.StaticFaqsAccessibility) {
    window.StaticFaqsAccessibility.initialize(document);
    return;
  }

  var COMPONENT_SELECTOR = '[data-static-faqs-section]';
  var TRIGGER_SELECTOR = '[data-faq-trigger]';
  var PANEL_SELECTOR = '[data-faq-panel]';
  var ANIMATION_DURATION = 250;

  function getPanel(trigger) {
    var panelId = trigger.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;

    if (!panel || !trigger.closest(COMPONENT_SELECTOR).contains(panel)) {
      return null;
    }

    return panel;
  }

  function getTrigger(panel) {
    var triggerId = panel.getAttribute('aria-labelledby');
    var trigger = triggerId ? document.getElementById(triggerId) : null;

    return trigger && trigger.matches(TRIGGER_SELECTOR) ? trigger : null;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function finishPanelState(panel, expanded) {
    panel.hidden = !expanded;
    panel.style.display = expanded ? 'block' : 'none';
  }

  function setExpanded(trigger, expanded, animate) {
    var panel = getPanel(trigger);

    if (!panel) {
      return;
    }

    trigger.setAttribute('aria-expanded', String(expanded));
    trigger.classList.toggle('active', expanded);
    panel.setAttribute('aria-hidden', String(!expanded));

    var shouldAnimate = animate && !prefersReducedMotion() && window.jQuery;

    if (!shouldAnimate) {
      finishPanelState(panel, expanded);
      return;
    }

    var $panel = window.jQuery(panel).stop(true, true);
    panel.hidden = false;

    if (expanded) {
      panel.style.display = 'none';
      $panel.slideDown(ANIMATION_DURATION, function () {
        finishPanelState(panel, true);
      });
    } else {
      $panel.slideUp(ANIMATION_DURATION, function () {
        finishPanelState(panel, false);
      });
    }
  }

  function initialize(scope) {
    var roots = [];

    if (scope.matches && scope.matches(COMPONENT_SELECTOR)) {
      roots.push(scope);
    }

    if (scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll(COMPONENT_SELECTOR)));
    }

    roots.forEach(function (root) {
      root.querySelectorAll(TRIGGER_SELECTOR).forEach(function (trigger) {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        setExpanded(trigger, expanded, false);
      });
    });
  }

  function onClick(event) {
    var trigger = event.target.closest(TRIGGER_SELECTOR);

    if (!trigger || !trigger.closest(COMPONENT_SELECTOR)) {
      return;
    }

    setExpanded(trigger, trigger.getAttribute('aria-expanded') !== 'true', true);
  }

  function onKeydown(event) {
    if (event.key !== 'Escape') {
      return;
    }

    var component = event.target.closest(COMPONENT_SELECTOR);

    if (!component) {
      return;
    }

    var expandedTrigger = event.target.closest(TRIGGER_SELECTOR + '[aria-expanded="true"]');
    var openPanel = event.target.closest(PANEL_SELECTOR + ':not([hidden])');
    var trigger = expandedTrigger || (openPanel ? getTrigger(openPanel) : null);

    if (!trigger) {
      return;
    }

    event.preventDefault();
    setExpanded(trigger, false, true);
    trigger.focus();
  }

  function onSectionLoad(event) {
    initialize(event.target);
  }

  function onBlockSelect(event) {
    var block = event.target.closest('.faq-cat-wrapper, .faq-inner-wrapper');

    if (!block || !block.closest(COMPONENT_SELECTOR)) {
      return;
    }

    var categoryPanel = block.closest('[data-faq-category-panel]');
    var categoryTrigger = categoryPanel ? getTrigger(categoryPanel) : null;

    if (categoryTrigger) {
      setExpanded(categoryTrigger, true, false);
    }

    var blockTrigger = block.classList.contains('faq-inner-wrapper')
      ? block.querySelector(TRIGGER_SELECTOR)
      : block.querySelector('.faq-cat-heading');

    if (blockTrigger) {
      setExpanded(blockTrigger, true, false);
    }
  }

  window.StaticFaqsAccessibility = { initialize: initialize };

  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKeydown);
  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:block:select', onBlockSelect);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }
})();
